// src/components/BucketCard.jsx
import React from "react";
import { FaList, FaCog, FaTrash } from "react-icons/fa";
import "./BucketCard.css";

export default function BucketCard({ bucket, onList, onSettings, onDelete }) {
  if (!bucket) return null;

  const {
    name = "—",
    objectsCount = 0,
    tamanhoFormatado = "—",
    regiao = "—",
    criadoEm,
    ultimaModificacao,
    retencaoAtiva = false,
    privado = true,
    versionamento = false,
    quota = null,
    quotaUsada = null,
  } = bucket;

  const formatDate = (dateString) =>
    new Date(dateString).toLocaleString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

  const Badge = ({ label, variant }) => (
    <span className={`badge bg-${variant}`}>{label}</span>
  );

  const renderQuota = () => {
    if (quota != null && quotaUsada != null) {
      return (
        <p>
          <strong>Quota:</strong> {quotaUsada} / {quota}
        </p>
      );
    }
    return (
      <p>
        <strong>Quota:</strong> Ilimitada
      </p>
    );
  };

  return (
    <div className="card bucket-card-component">
      {/* HEADER */}
      <div className="bucket-card-header">
        <h5 className="bucket-card-title">{name}</h5>
        <div className="bucket-actions">
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); onList(name); }}
            aria-label="Listar objetos"
          >
            <FaList />
          </button>
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); onSettings(name); }}
            aria-label="Configurações"
          >
            <FaCog />
          </button>
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); onDelete(name); }}
            aria-label="Excluir bucket"
          >
            <FaTrash />
          </button>
        </div>
      </div>

      {/* BODY */}
      <div className="bucket-card-body">
        <div className="date-badges">
          {criadoEm && (
            <span className="date-badge">
              Criado em: {formatDate(criadoEm)}
            </span>
          )}
          {ultimaModificacao && (
            <span className="date-badge">
              Modificado em: {formatDate(ultimaModificacao)}
            </span>
          )}
        </div>

        <p><strong>Objetos:</strong> {objectsCount.toLocaleString("pt-BR")}</p>
        {renderQuota()}
        <p><strong>Volume:</strong> {tamanhoFormatado}</p>
        <p><strong>Região:</strong> {regiao}</p>

        <div className="status-line">
          <strong>Status:</strong>
          <Badge label={privado ? "Privado" : "Público"} variant={privado ? "dark" : "info"} />
          <Badge label={retencaoAtiva ? "Retenção ativa" : "Sem retenção"} variant={retencaoAtiva ? "success" : "secondary"} />
          <Badge label={versionamento ? "Versionamento ON" : "Versionamento OFF"} variant={versionamento ? "primary" : "secondary"} />
        </div>
      </div>
    </div>
  );
}